import { useState } from "react";
import { useForm } from "hooks";
import { useApp, useService, useTheme } from "contexts";
import { Enums, Routes } from "utils";
import { useNavigate } from "react-router-dom";
import { IFeedback, createDefaultFeedback } from "interfaces";

export function useFeedbackForm(onSubmitCallback: (obj: IFeedback, success: boolean) => void) {
  const { t } = useApp();
  const { emailService, userService } = useService();

  const [values, setValues] = useState<IFeedback>(createDefaultFeedback());

  const { onChange } = useForm({}, undefined, undefined, (name, value) => {
    setValues((prev) => ({ ...prev, [name]: value }));
  });

  async function handleSubmit(event: React.FormEvent) {
    event.preventDefault();

    // const response = await userService.findByEmail(values.email);

    // if (response) {
    //   // send email
    //   emailService.feedback(
    //     response.email,
    //     t.message.subject.forgot_password,
    //     response._id,
    //     response.first_name,
    //     response.role
    //   );

    //   onSubmitCallback?.(response.email, true);
    // } else {
    //   onSubmitCallback?.(values.email, false);
    // }
  }

  return { t, values, setValues, onChange, handleSubmit };
}
